import React from 'react';
import { tagDef, TAG_COLORS } from '../lib/constants';
import { X } from 'lucide-react';

export function TagChip({ tagKey, onRemove, size = 'sm' }) {
  const def = tagDef(tagKey);
  const colors = TAG_COLORS[def.color] || TAG_COLORS.slate;
  return (
    <span
      data-testid={`tag-chip-${tagKey}`}
      className={`inline-flex items-center gap-1 rounded-full font-medium ${
        size === 'sm' ? 'text-[11px] px-2 py-0.5' : 'text-xs px-2.5 py-1'
      }`}
      style={{ backgroundColor: colors.bg, color: colors.fg }}
    >
      {def.label}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onRemove(tagKey); }}
          className="hover:opacity-70"
          aria-label="Rimuovi tag"
          data-testid={`tag-remove-${tagKey}`}
        >
          <X className="w-3 h-3" />
        </button>
      )}
    </span>
  );
}

export function ScoreBadge({ score, size = 'sm' }) {
  if (score == null) {
    return (
      <span className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium bg-[#E7ECEF] text-[#1F2A37]" data-testid="lead-score-badge">
        N/D
      </span>
    );
  }
  let bg = '#E7ECEF', fg = '#1F2A37', label = 'COLD';
  if (score >= 80) { bg = '#D7EFE6'; fg = '#0C3C2D'; label = 'HOT'; }
  else if (score >= 50) { bg = '#F3E7C7'; fg = '#6A4B00'; label = 'WARM'; }
  return (
    <span
      data-testid="lead-score-badge"
      className={`inline-flex items-center gap-1 rounded-full font-semibold ${size === 'sm' ? 'text-[11px] px-2 py-0.5' : 'text-xs px-2.5 py-1'}`}
      style={{ backgroundColor: bg, color: fg }}
      title="AI Lead Score"
    >
      <span>{score}</span>
      <span className="opacity-70">{label}</span>
    </span>
  );
}

export function BranchPill({ branch }) {
  const map = {
    pre_branch: { bg: '#F1E7D6', fg: '#5A4630', label: 'Pre-branch' },
    equity_estate: { bg: '#DCECF4', fg: '#2F7EA0', label: 'Equity Estate' },
    real_estate: { bg: '#D6F0F0', fg: '#0E5A5A', label: 'Real Estate' },
  };
  const c = map[branch] || map.pre_branch;
  return (
    <span
      data-testid={`branch-pill-${branch}`}
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{ backgroundColor: c.bg, color: c.fg }}
    >
      {c.label}
    </span>
  );
}
